import { useEffect, useState } from "react";
import {
  FETCH_FALLBACK_DELAY_MS,
  fetchStaggeredFallback,
  toBrowserUrls,
} from "../../client";

export interface Props {
  src: string | File;
  alt?: string;
  className?: string;
}

// Same as <img> but capable of `File`-objects and `ipfs://` urls.
export function Image(props: Props) {
  let src;
  if (typeof props.src === "string") {
    const urls = toBrowserUrls(props.src);
    if (urls.length === 1) {
      src = urls[0];
    } else {
      // Only setup the state if we need it.
      const [s, setSrc] = useState<string | undefined>();
      src = s;
      useEffect(() => {
        fetchStaggeredFallback(urls, FETCH_FALLBACK_DELAY_MS, (res) =>
          res.blob(),
        )
          .then((res) => setSrc(URL.createObjectURL(res!)))
          .catch((e) => console.error(e));
      }, [props.src]);
    }
  } else {
    src = URL.createObjectURL(props.src);
  }
  return <img className={props.className} src={src} alt={props.alt} />;
}
